import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import { NavMarker } from 'react-rhumb';
import { H4, H7 } from 'UIComponents/elements/headings';
import UILink from 'UIComponents/link/UILink';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import Badge, { BadgeGrid, EmptyBadge } from '../../../components/Badge';
import ErrorMessage from '../../../components/ErrorMessage';
import { PrerenderReady, PrerenderStatusCode } from '../../../components/Prerender';
import ScrollMarker from '../../../components/ScrollMarker';
import { useIsCurrentUser, useUserByUsername } from '../../users/userQueries';
import { useCommunityCredentials } from '../credentialsQueries';

const CommunityCredentials = ({
  username
}) => {
  const {
    communityCredentials,
    communityCredentialsLoading,
    communityCredentialsError,
    fetchMoreCommunityCredentials
  } = useCommunityCredentials(username);
  const {
    user
  } = useUserByUsername(username);
  const ownProfile = useIsCurrentUser(user ? user.userId : undefined);
  const displayName = user && user.displayName;
  const noCredentials = !communityCredentialsLoading && !communityCredentials.total;

  if (!communityCredentialsLoading && communityCredentialsError) {
    return /*#__PURE__*/_jsxs(NavMarker, {
      name: "PROFILE_LOAD_FAILURE",
      children: [/*#__PURE__*/_jsx(PrerenderStatusCode, {
        status: "500"
      }), /*#__PURE__*/_jsx(PrerenderReady, {}), /*#__PURE__*/_jsx(ErrorMessage, {
        type: "error"
      })]
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!communityCredentialsLoading && !communityCredentialsError && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: "COMMUNITY_TAB_LOADED"
      }), /*#__PURE__*/_jsx(PrerenderReady, {})]
    }), /*#__PURE__*/_jsx(H4, {
      className: "m-top-2 m-bottom-6",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "connectDotCom.profile.earnedBadges"
      })
    }), /*#__PURE__*/_jsxs(BadgeGrid, {
      $noEarnedBadges: noCredentials,
      className: "m-bottom-8",
      children: [noCredentials && /*#__PURE__*/_jsxs(EmptyBadge, {
        children: [ownProfile && /*#__PURE__*/_jsx(H7, {
          className: "m-bottom-1",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "connectDotCom.profile.noBadges"
          })
        }), ownProfile ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "connectDotCom.profile.youHaventEarnedBadges"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "connectDotCom.profile.someoneHasntEarnedBadges",
          options: {
            name: displayName
          }
        }), ownProfile && /*#__PURE__*/_jsx(UILink, {
          href: "https://community.hubspot.com",
          external: true,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "connectDotCom.profile.getStartedInCommunity"
          })
        })]
      }), communityCredentials.results.map(credential => /*#__PURE__*/_jsx(Badge, {
        icon: credential.badge,
        title: credential.title,
        earnedAt: credential.createdAt,
        href: credential.certificate
      }, credential.credentialId)), communityCredentialsLoading && /*#__PURE__*/_jsx(UILoadingSpinner, {
        "data-test-id": "credentials-loading"
      })]
    }), /*#__PURE__*/_jsx(ScrollMarker, {
      onEnterView: fetchMoreCommunityCredentials
    })]
  });
};

export default CommunityCredentials;